/**
 * Per-agent widget publishable keys (B4.2).
 * Raw secret is only returned from rotate — never listed afterward.
 */
import { get, post, patch } from '@core/api/client';
import { endpoints } from '@core/api/endpoints';

export interface WidgetPublishableKeyMetadata {
  id: string;
  agentId: string;
  keyPrefix: string;
  status: 'active' | 'revoked';
  allowedOrigins: string[];
  createdAt: string;
  revokedAt: string | null;
}

export interface RotateWidgetKeyResult {
  publishableKey: string;
  key: WidgetPublishableKeyMetadata;
}

export interface PreviewTokenResult {
  token: string;
  expiresInSeconds: number;
}

export const widgetKeysService = {
  list(agentId: string): Promise<WidgetPublishableKeyMetadata[]> {
    return get(endpoints.widgetKeys.list(agentId));
  },

  rotate(agentId: string, allowedOrigins?: string[]): Promise<RotateWidgetKeyResult> {
    return post(endpoints.widgetKeys.rotate(agentId), { allowedOrigins });
  },

  revoke(agentId: string, id: string): Promise<void> {
    return post(endpoints.widgetKeys.revoke(agentId, id), {});
  },

  /** Mint a short-lived preview token for the Test view. */
  previewToken(agentId: string): Promise<PreviewTokenResult> {
    return post(endpoints.widgetKeys.previewToken(agentId), {});
  },

  /** Replace the allowed-origins list on an active key. */
  setOrigins(agentId: string, id: string, allowedOrigins: string[]): Promise<void> {
    return patch(endpoints.widgetKeys.origins(agentId, id), { allowedOrigins });
  },
};
